export default "__VITE_ASSET__RMhbCfgb__"